module.exports = __webpack_public_path__ + "img/1106d_1.c480b3d2.jpg";